import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {
    inject,
    observer,
    setDocumentTitle,
    setUidToken,
    getlang,
    setlang,
} from 'src/helper/devTools.js'
import http from 'src/helper/http'

import { jumpToUser } from 'src/helper/webviewFun.js'
/* import Toast from '../../../component/Toast'
import ReminderBtn from 'src/component/RuleButton'
import LoadingComp from '../../../component/LoadingComp' */
import { history } from 'src/core/router'
import { isRtl } from 'src/helper/tool'

@inject('store')
@observer

export default class extends Component {
    constructor(props) {
        super(props)
        this.ruby = this.props.store.register('app/ruby')
        setDocumentTitle('AgentRecharge')
    }

    state = {
        uid: 0,
        lang: langM.ar,
        language: 'en',
        userInfo:{ },
        dateCenter:{},
        micTimeList:[],
    }

    async componentWillMount() {
        let { language } = this.props.location.query
        language =await getlang(language)
        console.log('language', language)
        // lang 文字对象
        // language 语言种类 (zh/ar/en/tr)
        this.setState({
            lang: setlang(language, langM),
            language: language,
        })
        let uid = await setUidToken(this.props.location.query)
        let searchUid = this.props.location.query.searchUid
        let month = this.props.location.query.month
        await this.RunOnStart(uid,searchUid)
        this.getUserInfo(searchUid ||uid)
        this.getUserMicTime(searchUid*1,month)
        this.getDateInfo(month,searchUid*1)
    }

    // 初始化/接口请求初始化
    RunOnStart = async (uid,searchUid) => {
        // 用户id
        this.setState({
            uid: uid,
            searchUid
        })
    }
    
    getUserInfo = async(uid)=>{
      let res = await http.post('/web/user/info', { uidDuid:uid })
      if (res.code == 0) {
        this.setState({ userInfo:res.res })
      }
    }
     
    getDateInfo = async(month,uid)=>{
        let res = await http.post('/web/guild/salary_info', { month,uid})
        if (res.code == 0) {
            this.setState({ dateCenter: res.res})
        }
    }

    getUserMicTime = async(uid,month)=>{
        let res = await http.post('/web/guild/member/on_mic_list', { uid, month })
        console.log(res)
        if (res.code == 0) {
            this.setState({ micTimeList: res.res.items || [], coinTotal:0})
        }
    }
    
    
    _setScore=(score) => {
        score = parseInt(score || 0)
        if (score > 1000000) {
          score = parseInt(score / 100000) / 10 + 'M'
        } else if (score >= 1000) {
          score = parseInt(score / 100) / 10 + 'K'
        }
        return score
      }
      
    render() {
        let { lang, language, userInfo, dateCenter, micTimeList } = this.state
        return (
            <div  className={`livetimeMic  ${isRtl(language) && 'arlang'}`}>
                <div className='' style={{ height: '0.44rem', backgroundColor: '#FFFFFF' }}></div>
                <div className='nav-top'>
                    <img className='close-view' style={{transform:`${isRtl(language) ? 'rotate(180deg)':''}`}} src='img/app/newhost/colse_cb.png' onClick={() => history.go(-1)}></img>
                    <div className='title-name'>{lang.LiveTime}</div>
                </div>
                <div className='mic-time-info-root'>
                    <div className='user-info'>
                        <img className='user-img-atv' onClick={()=>jumpToUser(userInfo && userInfo.uid)} src={userInfo && userInfo.avatarurl || ''} />
                        <div className='user-info-name-id'>
                            <div className='name-root'>{userInfo && userInfo.nickname || ''}</div>
                            <div className='id-root'>ID : {userInfo && userInfo.duid || ''}</div>
                        </div>
                    </div>
                    <div className='inlive-time'>
                    <div className='live-time-total'>
                            <div className='title'>{lang.total_received_coins}</div>
                            <div className='num'>{this._setScore(dateCenter.coin/100)}</div>
                        </div>
                    <div className='line-in'></div>
                        <div className='live-time-total'>
                            <div className='title'>{lang.totallivetime}</div>
                            <div className='num'>{dateCenter.on_mic_times && dateCenter.on_mic_times>0?(dateCenter.on_mic_times/60).toFixed(2):"0.00"}h</div>
                        </div>
                        <div className='line-in'></div>
                        <div className='hour'>
                            <div className='title'>{lang.bigTwoTime}</div>
                            <div className='num'>{dateCenter.active_days || 0}{lang.dayText}</div>
                        </div>
                    </div>
                    <div className='table-root-inmic'>
                        <div className='in-mic-title'>
                            <div className='in-mic-title-left'>{lang.date}</div>
                            <div className='in-mic-title-line'></div>
                            <div className='in-mic-title-left'>{lang.received_coins}</div>
                            <div className='in-mic-title-line'></div>
                            <div className='in-mic-title-right'>{lang.Durationonmic}</div>
                        </div>
                        <div className='time-list'>
                            {micTimeList.length>0 &&  micTimeList.map((item,index)=>(<div className='time-list-item' key={index}>
                                <div className='time-list-item-left'>{item.day}</div>
                                <div className='time-list-item-left'>{this._setScore(item.coin/100)}</div>
                                <div className='time-list-item-right'>{item.on_mic_times>0?(item.on_mic_times/60).toFixed(2):"0.00"}h</div>
                            </div>))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// src/pages/app/livetimeMic/index.js